<template>
  <div class="py-4">
    <v-card class="mx-auto" max-width="95%">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>게임의 전반적인 상태를 정의합니다..(개발중)</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small v-bind="attrs" v-on="on">
              <v-icon>mdi-help-circle</v-icon>
            </v-btn>
          </template>
          <span>서버 및 매출 정보 안내</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text class="pa-0">
        <v-list dense>
             
          <v-list-item class="grey lighten-3">
            <v-list-item-content class="text-center">
              <!-- <strong>[현재 유저 0명]</strong> -->
              <strong>[ 유저 정보 ]</strong>
               
            </v-list-item-content>
          </v-list-item>
               <v-container fluid class="pa-0">
            <v-row no-gutters>
               <v-col cols="12" sm="4">
                <v-card flat color="#E8F5E9" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between">
                    <strong>오늘 신규 가입자</strong>
                    <span>{{formatCoin( dashboard_info.newby_data) }} 명</span>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="4">
                <v-card flat color="#E3F2FD" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between">
                    <strong>전체 유저</strong>
                    <span>{{ formatCoin(dashboard_info.total_user_count) }} 명</span>
                  </div>
                </v-card>
              </v-col>    
              <v-col cols="12" sm="4">
                <v-card flat color="#F3E5F5" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between">
                    <strong>현재 접속자</strong>
                    <span>{{ formatCoin(dashboard_info.access_user_count) }} 명</span>
                  </div>
                </v-card>
              </v-col>             
            </v-row>
          </v-container>
            <v-list-item class="grey lighten-3">
              <v-list-item-content class="text-center">
                <!-- <strong>[현재 유저 0명]</strong> -->
                <strong>[ 코인정보 ]</strong>               
              </v-list-item-content>
            </v-list-item>
            <v-container fluid class="pa-0">
            <v-row no-gutters>
               <v-col cols="12" sm="4">
                <v-card flat color="#E8F5E9" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between">
                    <strong>누적 획득코인</strong>
                    <span>{{formatCoin( dashboard_info.coin_total)}}({{formatCoin_KRW( dashboard_info.coin_total * 50000)}})원 </span>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="4">
                <v-card flat color="#E3F2FD" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between">
                    <strong>현재 풀린코인</strong>
                    <span>{{formatCoin( dashboard_info.coin_current) }}({{formatCoin_KRW( dashboard_info.coin_current * 50000)}})원 </span>
                  </div>
                </v-card>
              </v-col>    
              <v-col cols="12" sm="4">
                <v-card flat color="#E3F2FD" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between">
                    <strong>사용된 코인</strong>
                    <span>{{formatCoin(  dashboard_info.coin_total - dashboard_info.coin_current) }} ({{formatCoin_KRW((dashboard_info.coin_total - dashboard_info.coin_current) * 50000)}})원 </span>
                  </div>
                </v-card>
              </v-col>                  
            </v-row>
          </v-container>
          <v-divider />
          <div class="my-6"></div>
          <v-list-item class="grey lighten-3">
            <v-list-item-content class="text-center">
              <strong>[오퍼월 오늘매출 : {{formatCoin(total_earn) }}원]</strong>
            </v-list-item-content>
          </v-list-item>
          <v-divider />         
          <v-container fluid class="pa-0">
            <template v-for="(bundle, bi) in sortedOfferwallBundles">
              <div v-if="bi > 0" :key="'ofw-gap-' + bi" style="height: 24px;"></div>
              <v-row no-gutters :key="'ofw-bundle-' + bi">
                <v-col cols="12" sm="6" v-for="o in bundle" :key="o.field">
                  <v-card flat :color="offerwallBundleColor(bi)" class="ma-1 pa-3">
                    <div class="d-flex justify-space-between">
                      <strong>{{ o.label }}</strong>
                      <span>{{ formatCoin(o.value) }} 원</span>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-container>
          <div class="my-6"></div>
          <v-list-item class="grey lighten-3">
            <v-list-item-content class="text-center">
              <strong>[ 매출 추이 ]</strong>
              <span class="ml-2 text-body-2">최근 30일 오퍼월 매출</span>
            </v-list-item-content>
          </v-list-item>
          <v-container fluid class="pa-3">
            <v-chip-group v-model="salesChartTab" mandatory active-class="primary--text" class="mb-3 sales-chart-chips">
              <v-chip :value="0" filter>전체</v-chip>
              <v-chip v-for="(platform, idx) in salesPlatformTabs" :key="idx" :value="idx + 1" filter>{{ platform.label }}</v-chip>
            </v-chip-group>
            <v-card flat class="mb-3 pa-3" color="blue lighten-5" style="border-left: 4px solid #1976D2;">
              <div class="d-flex justify-space-between align-center flex-wrap">
                <div>
                  <span class="text-caption grey--text">[{{ selectedChipLabel }}] 최근 30일 매출 합계</span>
                  <div class="text-h6 font-weight-bold primary--text">₩ {{ formatCoin_KRW(selectedChip30DaySum) }}</div>
                </div>
                <div class="text-right">
                  <span class="text-caption grey--text">건수 합계</span>
                  <div class="text-subtitle-1 font-weight-medium">{{ formatCoin(selectedChip30DayCount) }} 건</div>
                </div>
              </div>
            </v-card>
            <div v-show="salesChartTab === 0" class="sales-chart-panel">
              <div class="text-center mb-2">
                <v-chip color="primary" class="mr-2">매출 (원)</v-chip>
                <v-chip color="secondary">횟수</v-chip>
              </div>
              <div class="chart-container" style="height: 280px;">
                <line-chart v-if="!salesChartLoading && salesChartData" :chart-data="salesChartData" :options="salesChartOptions" />
                <div v-else-if="salesChartLoading" class="d-flex justify-center align-center" style="height: 100%;">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
                <div v-else class="d-flex flex-column justify-center align-center" style="height: 100%; color: #999;">
                  <v-icon size="48" class="mb-2">mdi-chart-line-variant</v-icon>
                  <span>데이터가 없습니다. 백엔드 API를 확인해주세요.</span>
                </div>
              </div>
            </div>
            <div v-for="(platform, idx) in salesPlatformTabs" :key="idx" v-show="salesChartTab === idx + 1" class="sales-chart-panel">
              <div class="text-center mb-2">
                <v-chip color="primary" class="mr-2">{{ platform.label }} 매출 (원)</v-chip>
                <v-chip color="secondary">횟수</v-chip>
              </div>
              <div class="chart-container" style="height: 280px;">
                <line-chart v-if="!salesChartLoading && platformChartData(platform.key)" :chart-data="platformChartData(platform.key)" :options="salesChartOptionsPlatform" />
                <div v-else-if="salesChartLoading" class="d-flex justify-center align-center" style="height: 100%;">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
                <div v-else class="d-flex flex-column justify-center align-center" style="height: 100%; color: #999;">
                  <span>데이터가 없습니다.</span>
                </div>
              </div>
            </div>
          </v-container>
        </v-list>
      </v-card-text>
    </v-card>

    <!-- 데일리 가입 유저 (별도 카드) -->
    <v-card class="mx-auto mt-4" max-width="95%">
      <v-toolbar color="deep-purple" dark dense>
        <v-icon left>mdi-account-plus</v-icon>
        <v-toolbar-title>데일리 가입 유저</v-toolbar-title>
        <v-spacer></v-spacer>
        <span class="text-caption">최근 30일 신규 가입자</span>
      </v-toolbar>
      <v-card-text class="pa-4">
        <div class="chart-container" style="height: 320px;">
          <line-chart v-if="signupChartData" :chart-data="signupChartData" :options="signupChartOptions" />
          <div v-else class="d-flex flex-column justify-center align-center" style="height: 100%; color: #999;">
            <v-icon size="48" class="mb-2">mdi-account-plus-outline</v-icon>
            <span>가입 데이터가 없습니다.</span>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- 일일 코인 (별도 카드) — DAILY_SALES_STATISTICS.COIN_EARN / COIN_USED / COIN_NET (크론이 PUBLIC_CASH_LOG 로 일 1회 기록) -->
    <v-card class="mx-auto mt-4" max-width="95%">
      <v-toolbar color="teal darken-1" dark dense>
        <v-icon left>mdi-chart-timeline-variant</v-icon>
        <v-toolbar-title>일일 코인</v-toolbar-title>
        <v-spacer></v-spacer>
        <span class="text-caption">최근 30일 · 획득 / 사용 / 순증(획득-사용)</span>
      </v-toolbar>
      <v-card-text class="pa-4">
        <v-row dense class="mb-2">
          <v-col cols="12" sm="4">
            <v-card flat color="#E8F5E9" class="pa-3">
              <div class="d-flex justify-space-between">
                <strong>30일 획득</strong>
                <span>{{ formatCoinDaily(coinDailySum.earn) }} 코인 ({{ formatCoin_KRW(coinToKRW(coinDailySum.earn)) }}원)</span>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card flat color="#FFEBEE" class="pa-3">
              <div class="d-flex justify-space-between">
                <strong>30일 사용</strong>
                <span>{{ formatCoinDaily(coinDailySum.used) }} 코인 ({{ formatCoin_KRW(coinToKRW(coinDailySum.used)) }}원)</span>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card flat color="#E3F2FD" class="pa-3">
              <div class="d-flex justify-space-between">
                <strong>30일 순증</strong>
                <span>{{ formatCoinDaily(coinDailySum.net) }} 코인 ({{ formatCoin_KRW(coinToKRW(coinDailySum.net)) }}원)</span>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div class="chart-container" style="height: 320px;">
          <line-chart v-if="coinChartData" :chart-data="coinChartData" :options="coinChartOptions" />
          <div v-else class="d-flex flex-column justify-center align-center" style="height: 100%; color: #999;">
            <v-icon size="48" class="mb-2">mdi-chart-timeline-variant</v-icon>
            <span>코인 기록이 없습니다. (크론 재시작 후 최근 30일이 소급됩니다)</span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>



<script>
    import axios from 'axios';
    import { mapActions } from 'vuex';
    import moment from 'moment';
    import store from '../../store';
    import config from '../../config/config';
    import { format, parseISO } from 'date-fns';
    import LineChart from '../billing/charts/LineChart';
    const { s3_upload, FileUpload_Async, FileUpload_JSON } = require('../../util/fileutil');

    // CPU 매출 플랫폼 (TNK, MALLPIE, POPCON, NAS, CPX, MAF, SNAPPLAY, SNAPPLAY_ROULLET, PINCRUX, GMO, DT, TYRADS, ADJO, TOTAL, TOTAL_CNT)
    const SALES_PLATFORM_KEYS = [
        { key: 'TNK', label: 'TNK' },
        { key: 'MALLPIE', label: '몰파이' },
        { key: 'POPCON', label: 'POPCON' },
        { key: 'NAS', label: 'NSTATION' },
        { key: 'CPX', label: 'CPX' },
        { key: 'MAF', label: 'MAF' },
        { key: 'SNAPPLAY', label: '스냅오퍼월' },
        { key: 'SNAPPLAY_ROULLET', label: '스냅룰렛' },
        { key: 'PINCRUX', label: '핀크럭스' },
        { key: 'GMO', label: 'GMO' },
        { key: 'DT', label: 'DT' },
        { key: 'TYRADS', label: 'TyrAds' },
        { key: 'ADJO', label: 'ADJO' }
    ];

    export default {
        name: 'UserList',
        components: { LineChart },

        data: () => ({
            // 오퍼월 매출 번들 — 번들끼리 한 칸 띄우고, 번들 내에서는 매출순(내림차순) 정렬
            offerwallBundles: [
                [
                    { label: '스냅오퍼월(룰렛포함)', field: 'snapplay' },
                    { label: 'TNK', field: 'tnk' },
                    { label: 'NSTATION', field: 'nstation' },
                    { label: '핀크럭스', field: 'pincrux_ticket' },
                ],
                [
                    { label: 'MAF', field: 'maf' },
                    { label: 'TyrAds', field: 'tyrads' },
                    { label: 'ADJO', field: 'adjo' },
                    { label: 'DT', field: 'dt' },
                    { label: 'GMO', field: 'gmo' },
                    { label: 'CPX', field: 'cpx' },
                    { label: 'POPCON', field: 'popcon' },
                ],
                [
                    { label: '몰파이', field: 'mallpie' },
                ],
            ],
            serverTime:'0000-00-00 00:00:00',
            date:moment().format('yyyy-MM-DD'),
         
    
            loadingData: false,


            package_name:'io.snapplay.cpu',
            gameName:'코인 채굴기',       
            is_using_table: false,
            
            aosVer: '',             //aos 최소 요구버전 이것보다 낮으면 업데이트 요청
            iosVer: '',             //ios 최소 요구버전 이것보다 낮으면 업데이트 요청 
            aosVer_Check: '',       //aos 검수중인 버전 특정 버전이 검수중일때만 액션이 필요한경우 처리한다 딱히 지정이 필요하지 않으면 "" , 아니면 버전입력 
            iosVer_Check: '',       //ios 검수중인 버전 특정 버전이 검수중일때만 액션이 필요한경우 처리한다 딱히 지정이 필요하지 않으면 "" , 아니면 버전입력 
            serverStateInfoList: [
                {
                    name: '정상 작동中',
                    value: '1'
                }, {
                    name: '서버 점검中',
                    value: '2'
                }
            ],
            selected_server_state_aos: '1', //aos 서버 점검 상태 라이브 : 1 , 점검 : 2
            selected_server_state_ios: '1', //ios 서버 점검 상태 라이브 : 1 , 점검 : 2
            server_checking_message: '죄송합니다. 지금은 잠시 서버 점검중입니다.',
            item_opt:[  {
                            "key": "10001",
                            "name": "CPU 증가 보너스 포인트"
                            }],
            table_file: [],
            table_file_version: "1.0.0",
            dashboard_info:{},
            total_earn : 0,

            salesChartTab: 0,
            dailySalesStatistics: [],
            salesPlatformTabs: SALES_PLATFORM_KEYS,
            salesChartLoading: false,

            // 데일리 가입 유저 차트 옵션
            // 일일 코인 차트 옵션 (코인은 소수라 4자리까지 표시)
            coinChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { display: true },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: (item, data) => data.datasets[item.datasetIndex].label + ': ' + Number(item.yLabel || 0).toLocaleString(undefined, { maximumFractionDigits: 4 })
                    }
                },
                scales: { yAxes: [{ ticks: { beginAtZero: true } }] }
            },
            signupChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { display: true },
                tooltips: { mode: 'index', intersect: false },
                scales: { yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }] }
            }

        }),

        created() {
            this.LoadDashboard_Info();
            this.LoadDailySalesStatistics();
        },

        methods: {
            // 번들별 카드 배경색
            offerwallBundleColor(bi) {
                const colors = ['#E3F2FD', '#FFF3E0', '#F3E5F5'];
                return colors[bi % colors.length];
            },
            ...mapActions([
                'GET_DASHBOARD_DATA',
                'CPU_GET_DAILY_SALES_STATISTICS',
            ]),
            LoadDashboard_Info()
            {//get_dashboard_data
                
                //if(this.$store.state.cpu_dash_borad_info.length == undefined || this.$store.state.cpu_dash_borad_info.length === 0){
                //this.$store.state.cpu_dash_borad_info.length == undefined || this.$store.state.cpu_dash_borad_info.length === 0 || 
                if(Object.keys(this.$store.state.cpu_dash_borad_info).length == 0){
                    console.log("TEST 2" + Object.keys(this.$store.state.cpu_dash_borad_info).length + "END");
                    this.GET_DASHBOARD_DATA({}).then((body_data)=>{
                        console.log("TEST 3");
                        let dashboard  = body_data.dashboard_data;
                        console.log(JSON.stringify(dashboard));
                        store.commit("SET_DASHBOARD_INFO", {cpu_dash_borad_info: dashboard})
                        this.dashboard_info = dashboard;   // 데일리 가입 차트 등 즉시 반영
                    })
                    .catch((err) => {
                        this.error = err;
                        console.log(err);
                    })
                }else 
                {
                    this.dashboard_info = this.$store.state.cpu_dash_borad_info;
                    this.total_earn = this.dashboard_info.tnk + this.dashboard_info.nstation + this.dashboard_info.snapplay + this.dashboard_info.popcon + this.dashboard_info.maf + this.dashboard_info.cpx + (this.dashboard_info.pincrux_ticket ?? 0) + (this.dashboard_info.gmo ?? 0) + (this.dashboard_info.mallpie ?? 0) + (this.dashboard_info.dt ?? 0) + (this.dashboard_info.tyrads ?? 0) + (this.dashboard_info.adjo ?? 0);
                }
            },
            LoadDailySalesStatistics() {
                this.salesChartLoading = true;
                this.CPU_GET_DAILY_SALES_STATISTICS({}).then((body_data) => {
                    this.salesChartLoading = false;
                    const data = body_data?.response_data || body_data?.result || body_data;
                    const list = data?.daily_sales_statistics ?? data?.daily_sales ?? (Array.isArray(data) ? data : []);
                    this.dailySalesStatistics = Array.isArray(list) ? list : [];
                }).catch((err) => {
                    this.salesChartLoading = false;
                    console.error('매출 통계 로드 실패:', err);
                    this.dailySalesStatistics = [];
                });
            },
            getRowValue(row, colKey) {
                if (!row) return 0;
                const val = row[colKey] ?? row[colKey.toLowerCase()] ?? 0;
                return Number(val) || 0;
            },
            getRowDate(row) {
                if (!row) return '';
                return row.SALE_DATE || row.sale_date || row.STAT_DATE || row.stat_date || '';
            },
            platformChartData(colKey) {
                const rows = this.dailySalesStatistics || [];
                if (!rows.length) return null;
                const labels = rows.map((r) => this.getRowDate(r)).reverse();
                const salesData = rows.map((r) => this.getRowValue(r, colKey)).reverse();
                const countData = rows.map((r) => this.getRowValue(r, colKey + '_CNT')).reverse();
                const label = SALES_PLATFORM_KEYS.find(p => p.key === colKey)?.label || colKey;
                return {
                    labels,
                    datasets: [
                        {
                            label: label + ' 매출 (원)',
                            backgroundColor: 'rgba(33, 150, 243, 0.2)',
                            borderColor: '#2196F3',
                            data: salesData,
                            fill: true,
                            yAxisID: 'y-sales'
                        },
                        {
                            label: '횟수',
                            backgroundColor: 'rgba(76, 175, 80, 0.2)',
                            borderColor: '#4CAF50',
                            data: countData,
                            fill: true,
                            yAxisID: 'y-count'
                        }
                    ]
                };
            },

            MakeSettingData_Json()
            {//서버 데이터를 json으로 변경후 반환한다 

                let result_server_state = {
                    "PACKAGE": "io.snapplay.cpu",
                    "NAME":"코인 채굴기",
                    "VERSION_AOS": this.aosVer,
                    "VERSION_IOS": this.iosVer,
                    "CHECK_VERSION_AOS": this.aosVer_Check,
                    "CHECK_VERSION_IOS": this.iosVer_Check,
                    "SERVER_STATE_AOS": this.selected_server_state_aos,
                    "SERVER_STATE_IOS": this.selected_server_state_ios,
                    "SERVER_CHECKING_MSG": this.server_checking_message,
                    "SERVICE_OPTION": {
                        "item_opt": [
                                    {
                                    "key": "10001",
                                    "name": "CPU 증가 보너스 포인트"
                                    }
                                ]
                    }

                };   
                return result_server_state;     
            },
            IsActiveState(_item) {
                return _item.active_yn == "Y"
                    ? true
                    : false;
            },
            async OnSaveDone() {

                const json_container = this.MakeSettingData_Json();

                    ///주성 파일 올리는것부터 하면 될듯 
                    console.log("저장:"+JSON.stringify(json_container));
                    this.loadingData = true;
                    var file_path = config.isLive?"project_cpu/manage/live/ServerState.json":"project_cpu/manage/dev/ServerState.json"
                    //https://content-filecenter.s3.ap-northeast-2.amazonaws.com/project_cpu/manage/dev/ServerState.json
                    if(await FileUpload_JSON(json_container, file_path))
                    {
                        this.loadingData = false;
                        //let commit_path = file_path;                
                        console.log(`s3 서버에 저장 되었습니다. ${file_path}`);
                        alert("저장완료");
                    }   
            },
            OnUserKick() {
                let result = confirm("유저킥을 실행하시는경우 접속중인 유저의 세션이 끊어져 재접속이 될 수 있습니다.",);
                if (result) {
                    alert("유저킥 아직 지원하지 않는 기능입니다.");
                }
            },
            OnResetServer() {
                let packageName = this.$store.state.selected_game_package;
                if (confirm(`[[-->  ${packageName}  <--]]     
                서버의 모든 유저데이터를 지웁니다. 신중하게 결정했습니까?`)) {                    
                    this
                        .DELETE_USER_ALL({packageName})
                        .then((body_data) => {
                            alert("완료");
                        });
                }
            },
            Refresh_ItemInfo() {},
            IsSever_Checking() {
                if (this.selected_server_state_ios == '2' || this.selected_server_state_aos == '2') 
                    return true;
                else 
                    return false;
            },
            formatCoin(value) {
                if (value == null || value === '') return '0';
                const n = Number(value);
                return isNaN(n) ? '0' : n.toLocaleString();
            },
            // 일일 코인 표시 (소수 4자리까지)
            formatCoinDaily(v) {
                const n = Number(v);
                return isNaN(n) ? '0' : n.toLocaleString(undefined, { maximumFractionDigits: 4 });
            },
            // 코인 → 원화 환산 (상단 코인정보 카드와 동일 기준)
            coinToKRW(v) {
                return Number(v || 0) * 50000;
            },
            formatCoin_KRW(value) {
                if (value == null || value === '') return '0';
                const n = Number(value);
                return isNaN(n) ? '0' : Math.floor(n).toLocaleString();
            },
           
            async getServerTime () {
                // 로컬스토리지에서 현재 설정되어있는 package를 가져온다.
                // const packageName = this.$store.state.selected_game_package;
                // const requestResult = await this.GET_SERVER_TIME({packageName})
                // this.serverTime = requestResult.serverTime
                // this.changableServerTime = requestResult.changableServerTime
            },
            async setServerTime () {
                // const packageName = this.$store.state.selected_game_package;
                // const serverTime = this.dateTime
                // const requestResult = await this.SET_SERVER_TIME({packageName, serverTime})
                // if(requestResult.result){
                //     alert('서버 시간을 변경하였습니다.')
                //     this.getServerTime()
                // }
            },
            async rollBackServerTime () {
                // const packageName = this.$store.state.selected_game_package;
                // const requestResult = await this.ROLLBACK_SERVER_TIME({packageName})
                // if(requestResult.result){
                //     alert('서버 시간을 되돌렸습니다.')
                //     this.getServerTime()
                // }
            },
        },
        computed: {
            // 일일 코인 행 — COIN_* 컬럼이 있는 행만, 날짜 오름차순 (목록은 PID 순이라 날짜가 섞일 수 있음)
            coinDailyRows() {
                return (this.dailySalesStatistics || [])
                    .filter((r) => r && r.COIN_EARN !== undefined && r.COIN_EARN !== null)
                    .map((r) => ({
                        date: String(this.getRowDate(r) || '').substring(0, 10),
                        earn: Number(r.COIN_EARN) || 0,
                        used: Number(r.COIN_USED) || 0,
                        net: Number(r.COIN_NET) || 0,
                    }))
                    .filter((r) => r.date)
                    .sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
            },
            coinDailySum() {
                return this.coinDailyRows.reduce((acc, r) => ({
                    earn: acc.earn + r.earn, used: acc.used + r.used, net: acc.net + r.net,
                }), { earn: 0, used: 0, net: 0 });
            },
            coinChartData() {
                const rows = this.coinDailyRows;
                if (!rows.length) return null;
                return {
                    labels: rows.map((r) => r.date),
                    datasets: [
                        { label: '획득', borderColor: '#43A047', backgroundColor: 'rgba(67, 160, 71, 0.1)', data: rows.map((r) => r.earn), fill: false },
                        { label: '사용', borderColor: '#E53935', backgroundColor: 'rgba(229, 57, 53, 0.1)', data: rows.map((r) => r.used), fill: false },
                        { label: '순증(획득-사용)', borderColor: '#1E88E5', backgroundColor: 'rgba(30, 136, 229, 0.15)', data: rows.map((r) => r.net), fill: true },
                    ]
                };
            },
            // 데일리 가입 유저 차트 데이터 — 매출 차트와 독립. 백엔드는 가입 있는 날만 반환하므로 최근 30일 전체를 0으로 채워 연속 그래프로 표시
            signupChartData() {
                const rows = (this.dashboard_info && this.dashboard_info.daily_newby) || [];
                if (!rows.length) return null;
                const map = {};
                rows.forEach((r) => {
                    const d = String(r.DT || r.dt || '').substring(0, 10);
                    if (d) map[d] = Number(r.CNT ?? r.cnt ?? 0);
                });
                const labels = [];
                const data = [];
                for (let i = 29; i >= 0; i--) {
                    const d = moment().subtract(i, 'days').format('YYYY-MM-DD');
                    labels.push(d);
                    data.push(map[d] || 0);
                }
                return {
                    labels,
                    datasets: [{
                        label: '데일리 가입 유저',
                        backgroundColor: 'rgba(156, 39, 176, 0.2)',
                        borderColor: '#9C27B0',
                        data,
                        fill: true,
                    }]
                };
            },
            // 번들별로 매출값을 붙이고 매출 내림차순 정렬
            sortedOfferwallBundles() {
                return this.offerwallBundles.map(bundle =>
                    bundle
                        .map(o => ({ ...o, value: Number(this.dashboard_info[o.field] ?? 0) }))
                        .sort((a, b) => b.value - a.value)
                );
            },
            selectedChipKey() {
                if (this.salesChartTab === 0) return 'TOTAL';
                const platform = this.salesPlatformTabs[this.salesChartTab - 1];
                return platform ? platform.key : 'TOTAL';
            },
            selectedChipLabel() {
                if (this.salesChartTab === 0) return '전체';
                const platform = this.salesPlatformTabs[this.salesChartTab - 1];
                return platform ? platform.label : '전체';
            },
            selectedChip30DaySum() {
                const rows = this.dailySalesStatistics || [];
                const key = this.selectedChipKey;
                return rows.reduce((acc, r) => acc + (this.getRowValue(r, key) || 0), 0);
            },
            selectedChip30DayCount() {
                const rows = this.dailySalesStatistics || [];
                const key = this.selectedChipKey === 'TOTAL' ? 'TOTAL_CNT' : (this.selectedChipKey + '_CNT');
                return rows.reduce((acc, r) => acc + (this.getRowValue(r, key) || 0), 0);
            },
            salesChartData() {
                const rows = this.dailySalesStatistics || [];
                if (!rows.length) return null;
                const labels = rows.map((r) => this.getRowDate(r)).reverse();
                const salesData = rows.map((r) => this.getRowValue(r, 'TOTAL')).reverse();
                const countData = rows.map((r) => this.getRowValue(r, 'TOTAL_CNT')).reverse();
                return {
                    labels,
                    datasets: [
                        {
                            label: '매출 (원)',
                            backgroundColor: 'rgba(33, 150, 243, 0.2)',
                            borderColor: '#2196F3',
                            data: salesData,
                            fill: true,
                            yAxisID: 'y-sales'
                        },
                        {
                            label: '횟수',
                            backgroundColor: 'rgba(76, 175, 80, 0.2)',
                            borderColor: '#4CAF50',
                            data: countData,
                            fill: true,
                            yAxisID: 'y-count'
                        }
                    ]
                };
            },
            salesChartOptions() {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: { duration: 0 },
                    layout: { padding: { bottom: 32, top: 16 } },
                    tooltips: {
                        mode: 'index',
                        callbacks: {
                            label: function(tooltipItem, data) {
                                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                const label = data.datasets[tooltipItem.datasetIndex].label;
                                if (label && label.includes('횟수')) return label + ': ' + value + '건';
                                return label + ': ₩' + (value >= 1000 ? Number(value).toLocaleString() : value);
                            }
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-sales',
                                type: 'linear',
                                position: 'left',
                                ticks: { beginAtZero: true, padding: 8, callback: (v) => v >= 1000 ? '₩' + Number(v).toLocaleString() : '₩' + v }
                            },
                            {
                                id: 'y-count',
                                type: 'linear',
                                position: 'right',
                                gridLines: { drawOnChartArea: false },
                                ticks: { beginAtZero: true, padding: 8 }
                            }
                        ]
                    }
                };
            },
            salesChartOptionsPlatform() {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: { duration: 0 },
                    layout: { padding: { bottom: 32, top: 16 } },
                    tooltips: {
                        mode: 'index',
                        callbacks: {
                            label: function(tooltipItem, data) {
                                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                const label = data.datasets[tooltipItem.datasetIndex].label;
                                if (label && label.includes('횟수')) return label + ': ' + value + '건';
                                return label + ': ₩' + (value >= 1000 ? Number(value).toLocaleString() : value);
                            }
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-sales',
                                type: 'linear',
                                position: 'left',
                                ticks: { beginAtZero: true, padding: 8, callback: (v) => v >= 1000 ? '₩' + Number(v).toLocaleString() : '₩' + v }
                            },
                            {
                                id: 'y-count',
                                type: 'linear',
                                position: 'right',
                                gridLines: { drawOnChartArea: false },
                                ticks: { beginAtZero: true, padding: 8 }
                            }
                        ]
                    }
                };
            },
            isLive() {
                return config.isLive;
            },
            serverState_URL () {
                return config.serverState_URL_CPU;
            },
            computedDateFormattedMomentjs_begin() {
                return this.date_begin
                    ? moment(this.date_begin).format('YYYY-MM-DD')
                    : ''
            },
            computedDateFormattedMomentjs_end() {
                return this.date_end
                    ? moment(this.date_end).format('YYYY-MM-DD')
                    : ''
            },
            dateTime() {
                return this.date + ' ' + this.time1;
            },
        },
        watch: {        
            '$store.state.cpu_dash_borad_info': function() {
                 this.dashboard_info = this.$store.state.cpu_dash_borad_info;
                this.total_earn = this.dashboard_info.tnk + this.dashboard_info.nstation + this.dashboard_info.snapplay + this.dashboard_info.popcon + this.dashboard_info.maf + this.dashboard_info.cpx + (this.dashboard_info.pincrux_ticket ?? 0) + (this.dashboard_info.gmo ?? 0) + (this.dashboard_info.mallpie ?? 0) + (this.dashboard_info.dt ?? 0) + (this.dashboard_info.tyrads ?? 0) + (this.dashboard_info.adjo ?? 0);
                //           this.total_earn = this.dashboard_info.tnk + this.dashboard_info.nstation + this.dashboard_info.snapplay + this.dashboard_info.popcon  + this.dashboard_info.maf + this.dashboard_info.cpx;
          }
        }

    };
</script>

<style scoped>
.sales-chart-chips {
  flex-wrap: wrap;
}
/*
 * chart.js(반응형)는 canvas의 '직접 부모'를 기준으로 크기를 잡는다.
 * vue-chartjs 는 canvas 를 wrapper <div>(height 없음=auto) 로 한 번 더 감싸므로,
 * .chart-container 에만 고정높이를 줘도 chart.js 는 그 안쪽 wrapper 를 보고 무한 확장한다.
 * → 실제 측정 대상인 wrapper div(.chart-container > div) 를 100% 로 채워 높이를 강제해 오버플로를 막는다.
 */
.chart-container {
  position: relative;
  width: 100%;
}
.chart-container > div {
  position: relative;
  height: 100%;
}
</style>